const items = {
  "error.email.exists": "该邮箱已经存在",
};

export default items;
